export default __webpack_public_path__ + "static/media/gco-logo.1cbb5389.png";